export const educationData = [
    {
        id: 1,
        institution: 'Lviv Physics and Mathematics Lyceum',
        course: 'Higher Secondary Education',
        startYear: '2007',
        endYear: '2008'
    },
    {
        id: 2,
        institution: 'St. Louis School, Hong Kong',
        course: 'Higher Secondary Education',
        startYear: '2008',
        endYear: '2011'
    },
    {
        id: 3,
        institution: 'Hong Kong Design Institute',
        course: 'Bachelor of Technology',
        startYear: '2011',
        endYear: '2016'
    },
]